import { createSlice } from "@reduxjs/toolkit";
import { users_roles } from "../../../types/user_service";

export const userMgt_getRoles = createSlice({
  name: "users management get roles",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: users_roles;
      }[],
      data: [] as users_roles,
    },
  },
  reducers: {
    user_mgt_updateRoles: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    user_mgt_addRole: (state, action) => {
      const {
        id,
        name,
        deleted_at,
        created_at,
        updated_at,
        created_by,
        type,
        permissions_reformed,
        role_has_permissions,
      } = action?.payload;
      state.value.data = [
        ...state.value.data,
        {
          id,
          name,
          deleted_at,
          created_at,
          updated_at,
          created_by,
          type,
          permissions_reformed,
          role_has_permissions,
        },
      ];
    },
    addToPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    user_mgt_removeRole: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    user_mgt_replaceRole: (state, action) => {
      const {
        id,
        name,
        deleted_at,
        created_at,
        updated_at,
        created_by,
        type,
        permissions_reformed,
        role_has_permissions,
      } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, {
        id,
        name,
        deleted_at,
        created_at,
        updated_at,
        created_by,
        type,
        permissions_reformed,
        role_has_permissions,
      });
      state.value.data = currentArray;
    },
    user_mgt_append_permissions: (state, action) => {
      const { id, permissions_reformed } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      const currentitem = currentArray[currentIndex];
      currentArray.splice(currentIndex, 1, {
        ...currentitem,
        permissions_reformed,
      });
      state.value.data = currentArray;
    },
    user_mgt_clearRoles: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  user_mgt_updateRoles,
  user_mgt_addRole,
  addToPaginationHistory,
  user_mgt_removeRole,
  user_mgt_replaceRole,
  user_mgt_clearRoles,
  user_mgt_append_permissions,
} = userMgt_getRoles.actions;

export default userMgt_getRoles.reducer;
